<template>

    <div class="full-preloader" v-if="posStyle == 'full'" :style="toggle?'display:block':'display:none'">
        <div class="full-preloader-inner">
            <div class="full-preloader-img"></div>
        </div>
    </div>

    <div class="dynamic-preloader" v-else-if="posStyle == 'dynamic'" :style="toggle?'display:block':'display:none'">
        <div class="dynamic-preloader-inner">
            <div class="dynamic-preloader-img"></div>
        </div>
    </div>
    <div class="full-preloader" v-else :style="toggle?'display:block':'display:none'">
        <div class="full-preloader-inner">
            <div class="full-preloader-img"></div>
        </div>
    </div>
</template>
<script>
import {ref,computed} from 'vue'
export default {
    name:'CreditFixrrLoader',
    components:{

    },
    props:{
        styleType: {
            type: String,
        },
        toggle:{
            type: Boolean,
        }
    },
    setup(props){
        const posStyle = computed(()=>{
            return props.styleType;
        });
        return{
            posStyle
        }
    },
}
</script>
<style>
    .full-preloader {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        margin: auto;
        opacity: 1;
        -webkit-transition: linear .3s ease;
        -moz-transition: linear .3s ease;
        transition: linear .3s ease;
        z-index: 9999;
        background: #212121;
    }
    .full-preloader-inner{
        width: 100vw;
        height: 100vh;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }
    .full-preloader-inner .full-preloader-img{
        border-width: 5px;
        border-style: solid;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        animation: spin 2s linear infinite;
        border-color: #2d2d2d;
        border-top-color: #4b9a5e;
    }
    .dynamic-preloader{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        margin: auto;
        opacity: 1;
        transition: linear .3s ease;
        z-index: 9999;
        background: #212121eb;
    }
    .dynamic-preloader-inner{
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }
    .dynamic-preloader-inner .dynamic-preloader-img{
        border-width: 5px;
        border-style: solid;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        animation: spin 2s linear infinite;
        border-color: #2d2d2d;
        border-top-color: #4b9a5e;
    }
</style>
